import React from 'react';
import { Typography } from '@klp/design';
import { useTranslation } from 'react-i18next';
import type { Company, CompanyKeys } from '../../services/rtkApi';

export type CompanyDetailsProps = {
    company: Company;
    name: CompanyKeys;
};
export const CompanyDetails = ({ company, name }: CompanyDetailsProps) => {
    const { t } = useTranslation();
    const hasProperty = Boolean(
        Object.prototype.hasOwnProperty.call(company, name),
    );
    const value: boolean | string | null | undefined = hasProperty
        ? company[name]
        : undefined;
    const displayValue = (): string => {
        if (value === undefined || value === null) {
            return '-';
        } else {
            return value ? t('general.confirm') : t('general.decline');
        }
    };

    return (
        <Typography>
            {t(`project.formFields.firmaDetaljer.${name}`)}:{' '}
            {hasProperty ? displayValue() : '-'}
        </Typography>
    );
};
